var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_230_7630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2982 8.99997L14.0852 5.21293C14.3042 4.99391 14.3042 4.63848 14.0852 4.41911L13.2052 3.53915C12.9862 3.32012 12.6308 3.32012 12.4114 3.53915L8.62474 7.32653L4.83771 3.5395C4.61868 3.32047 4.26325 3.32047 4.04388 3.5395L3.16427 4.41911C2.94524 4.63813 2.94524 4.99356 3.16427 5.21293L6.9513 8.99997L3.16427 12.787C2.94524 13.006 2.94524 13.3615 3.16427 13.5808L4.04423 14.4608C4.26325 14.6798 4.61868 14.6798 4.83806 14.4608L8.62474 10.6734L12.4118 14.4604C12.6308 14.6795 12.9862 14.6795 13.2056 14.4604L14.0856 13.5805C14.3046 13.3615 14.3046 13.006 14.0856 12.7866L10.2982 8.99997Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_230_7630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.25,
    height: 18,
    fill: "white",
    transform: "translate(3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.412c8f75bac448d2dd90963eac8e2ba2.svg";
export { ForwardRef as ReactComponent };